module.exports = "Search: <input type=\"text\" [(ngModel)]=\"textInput\">\n<button (click)=\"search()\">Cerca</button>\n"